import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { useCreateCatalogMutation } from "@modules/catalogs/services/mutations";
import { CatalogFormValues, catalogSchema } from "@modules/catalogs/validations";
import { listCatalogsQueryKey } from "@modules/catalogs/services/queries/listCatalogs/query";

export function useCreateCatalogModal(modalRef: RefObject<ModalRef>, onComplete?: () => void) {
  const queryClient = useQueryClient();
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<CatalogFormValues>({
    resolver: zodResolver(catalogSchema()),
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useCreateCatalogMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listCatalogsQueryKey,
        refetchType: 'all',
      });

      open?.({
        type: "success",
        message: translate("catalog.success.create"),
      });
      onComplete?.();
      modalRef.current?.close();
    },
  });


  return {
    methods,
    mutateAsync,
    isPending,
  };
}
